function Loading() {
    return (
        <div className="relative flex h-full w-full flex-col justify-center items-center overflow-x-hidden">
            <div className="w-10 h-10 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
        </div>
    );
}

export default Loading;